var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "16 15 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M20.035 21.161c0-2.708 2.212-4.91 4.93-4.91 2.72 0 4.93 2.202 4.93 4.91s-2.21 4.91-4.93 4.91c-2.718 0-4.93-2.202-4.93-4.91m7.886 5.41a6.162 6.162 0 0 0 3.23-5.41c0-3.397-2.774-6.161-6.185-6.161-3.411 0-6.187 2.764-6.187 6.161a6.163 6.163 0 0 0 3.231 5.41C18.515 27.792 16 31.108 16 35h1.256c0-4.234 3.459-7.678 7.71-7.678 4.25 0 7.71 3.444 7.71 7.678h1.255c0-3.893-2.515-7.209-6.01-8.428"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProfile);
export default __webpack_public_path__ + "static/media/header-profile.351799e0349bd1d37dcbca98014cc1fc.svg";
export { ForwardRef as ReactComponent };